<div fxLayout="column" fxLayoutGap="20px" class="layout-padd" fxLayoutAlign="center center"
  [ngStyle]="{'max-height.px': innerHeight}" fxFlexFill>


  <!-- title -->
  <div fxLayout="row" fxLayoutAlign="center center" class="dividerpop layout-padd-2 full-w text-center"
    ngClass.xs="layout-padd-5 full-w text-center">
    <div fxFlex="10%" fxLayoutAlign="start center">
      <mat-icon class=" redcolor">warning</mat-icon>
    </div>
    <h3 class="grey ">{{'alertStockComponent.outofstock' | translate}} </h3>
  </div>

  <!-- text -->
  <div ngClass.xs="textsmall" class="text-center ">
    {{'alertStockComponent.unavailable' | translate}}
   
    <br>
    {{'alertStockComponent.delete' | translate}}
    
     
  </div>
 

  <!-- prod -->

  <div ngClass=" full-w full-heigth" ngClass.xs=" full-w min-heigth" >
   
  
    <table mat-table [dataSource]="dataSource"  matSort matSortActive="count" matSortDirection="asc" matSortDisableClear class="scroll" >

        
      <!-- name  -->
     
      <ng-container matColumnDef="name" >
        <th mat-header-cell *matHeaderCellDef >{{'alertStockComponent.nostockProduct' | translate}} </th>
        <td mat-cell *matCellDef="let element " style="width: 70%;">
          <div fxLayout="row" fxLayoutGap="10px" class=" full-w" > 
          <img *ngIf="element.image.length > 0" [src]="element.image[2]" class="basket-prod-img">
          <img *ngIf="element.image.length ==0" [src]="default_prod" class="basket-prod-img">
          <div class="rowHeight">{{element.name}}</div>
          </div>
        </td> 
      </ng-container>
  
     
      <!-- name  -->
      <!-- <ng-container matColumnDef="name">
        <th mat-header-cell *matHeaderCellDef >Produit(s) </th>
        <td mat-cell *matCellDef="let element" > {{element.name}} </td>
      </ng-container> -->
    
      <!-- count  -->
      <ng-container matColumnDef="count">
        <th mat-header-cell *matHeaderCellDef mat-sort-header >{{'alertStockComponent.qteDelete' | translate}}  </th>
        <td mat-cell *matCellDef="let element"  style="width: 30%;"> {{element.count}} </td>
      </ng-container>
    
        
      <tr mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></tr>
      <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
   
    </table>
          


 
 </div> 

  <!-- button -->
  <button mat-stroked-button class="full-w dark-ico" (click)="closeDial()" angulartics2On="click"
    angularticsAction="closeMaxWeightDial" angularticsCategory="order">
    <span class="mat-title">{{"dialogs.go-back" | translate}}</span>
  </button>

</div>

